export const APPLE_TV =
  '//images.ctfassets.net/n36b8lzdmgnp/2zflBQcEbaqZ8V7OByFGsZ/5eba313c0397846dcd7cb4e4167dc6f8/apple-tv-plus.png?h=250'

export const NETFLIX =
  '//images.ctfassets.net/n36b8lzdmgnp/Mg9v2rCnhtsz10pcK94GP/e08952b836d59eb71af670593a3030a0/netflix.png?h=250'

export const PARAMOUNT_PLUS =
  '//images.ctfassets.net/n36b8lzdmgnp/qTJ5XsyWhSVnD88k959eM/6ba6bce34a30c5d45c183d55b0f333f5/paramount-plus.png?h=250'

export const VOXI =
  '//images.ctfassets.net/n36b8lzdmgnp/2JIQcDG3C462XdZMusHhZI/47f22e922687dd053b86fb299305d149/Voxi.png?h=250'

export const CHANNEL_4 =
  '//images.ctfassets.net/n36b8lzdmgnp/1XO0vCPFdwPAcG3C0rQget/a6826a30be526685502c087d90d86d86/channel-4.png?h=250'

export const AMAZON_PRIME =
  '//images.ctfassets.net/n36b8lzdmgnp/62fsMasA3BRTe12dZ0RqPn/e1a56e4317f22d65c17ebf0123d4bb17/amazon-prime-video.png?h=250'

export const BBC_IPLAYER =
  '//images.ctfassets.net/n36b8lzdmgnp/158ymzHx5fSvs6l3Q8RO1a/0c1dad8614f4f91969dee884ede651cb/bbc-iplayer.png?h=250'

export const NOW_TV =
  '//images.ctfassets.net/n36b8lzdmgnp/7y3reFFF8V3WvvdscCbvvQ/28cf2571de63de6e92093d67d0db2401/Vector__1_.png?h=250'

export const GIFF_GAFF =
  '//images.ctfassets.net/n36b8lzdmgnp/G6MvPP0lRzZVoRxWcYUgE/97ba588a7d74980841aab1578264eeea/giffgaff.png?h=250'

export const VODAPHONE =
  '//images.ctfassets.net/n36b8lzdmgnp/4l2d1z2IMDR0OfnKmuL5OB/e11ce71cc37779ef8ce17fe464aaf180/vodafone__1_.png?h=250'

export const TALK_TALK =
  '//images.ctfassets.net/n36b8lzdmgnp/xbtkV00oFlal5Blz260vh/540c993e01c0509c58dc444a7521cf19/talktalk__1_.png?h=250'

export const O2 =
  '//images.ctfassets.net/n36b8lzdmgnp/4BsV9ktTn2xhuF4YEM8IEy/7ca89187ec1098544bacd3b70f5a0f80/O2-01.png?h=250'

export const VIRGIN_MEDIA =
  '//images.ctfassets.net/n36b8lzdmgnp/5D6nKlNEbgMFuJvlbsK1IT/7cc51770d698aa98895b2c37b184db36/virgin-media-logo__1_.png?h=250'

export const PLUSNET =
  '//images.ctfassets.net/n36b8lzdmgnp/79GsEBkdBPNTAaXlc2TfiT/d0777d70f77170c83e26d28aed71448b/plusnet__1_.png?h=250'

export const BT =
  '//images.ctfassets.net/n36b8lzdmgnp/XXRmqBK5Aez7ajp1HHv06/286a5ce6b0f934ca945aa0be8178bbf6/BT_Consumer-Logo.png?h=250'

export const DISNEY_PLUS =
  '//images.ctfassets.net/n36b8lzdmgnp/5K7RjeehFBq5KTWtUJDYFR/67a754feb685405aba00cd34cac778aa/Disney-Plus__1_.png?h=250'

export const THREE =
  '//images.ctfassets.net/n36b8lzdmgnp/sBT8BNeQ4cn8PUEsrdbDa/6832c376f37f81d72c052b1b8aa7022c/3.png?h=250'

export const TESCO_MOBILE =
  '//images.ctfassets.net/n36b8lzdmgnp/1jZYBBjsYxQKF02DtSVo7T/8bb9c2e65cdc05979e496aad9f4c8d19/Tesco_Mobile_Logo_Vector.png?h=250'

export const EE =
  '//images.ctfassets.net/n36b8lzdmgnp/7I39bJFZ6xXHHQQCMatILe/b97de6b2fe0edc78da17a8dcd5e22129/ee_1.png?h=250'

export const SKY =
  '//images.ctfassets.net/n36b8lzdmgnp/7sceEa2TrPgXlXNPhf73s7/7c384b1df1b6599703d54c18f2681019/sky__1_.png?h=250'

export const LYCA_MOBILE =
  '//images.ctfassets.net/n36b8lzdmgnp/3VVnJzkkVzjOFAefq8XYM1/a8979e5b61ea5807eea8c4efb89304e4/Lycamobile.png?h=250'

export const SMARTY =
  '//images.ctfassets.net/n36b8lzdmgnp/4TAz58u70r5LrAZi6fZ3sn/ecb9dcd7e91efe5cbf5f9eb67ae7fe65/Frame.png?h=250'

export const GIGACLEAR =
  '//images.ctfassets.net/n36b8lzdmgnp/3DPgctSWKx8irkBKgN4RFD/6270e11033f5eefcdf2c16f6ef5d7078/Gigaclear.svg'

export const COMMUNITY_FIBRE =
  '//images.ctfassets.net/n36b8lzdmgnp/75SpN8230vWqWUQ80k2NSh/bf6ea418f88466ab3ea26a6daf4c7e1e/CommunityFibreBW.png?h=250'

export const SEE_THE_LIGHT =
  '//images.ctfassets.net/n36b8lzdmgnp/5kEWJeynjWEsa86VqVvYKf/55427741850058b32ad5af8dc8fcb81d/logo-2x_1.svg'

export const HYPEROPTIC =
  '//images.ctfassets.net/n36b8lzdmgnp/564JR0QxI2ouwsLe1W8IWl/6d5c2dbfe289d18128e0c16772a010dd/hyperoptic-b_w_1.svg'

export const APPLE =
  '//images.ctfassets.net/g836doytpz4a/7CEkS2vKpKUWDhD0uMUOet/e131e3adc167bea5a791958dd7ba1eb0/Apple_logo_black_1.svg'

export const MUSIC_MAGPIE =
  '//images.ctfassets.net/g836doytpz4a/4LAisVvVt08hAo5HIjnEfX/f26370afc87641f2e6f8454b870c788b/Music_Magpie.svg'

export const PIXEL =
  '//images.ctfassets.net/n36b8lzdmgnp/5BKNUB5T2bAKHjDjsiLSSK/1044fb54d4f3b35ea2b765a119acc500/Group-Pixel.svg'

export const AIRALO =
  '//images.ctfassets.net/n36b8lzdmgnp/5aTGHmcnF90zUo4GEuy6l2/85ff4badf8dd3fd0302ec03402cc66a3/Airalo-Logo_Vertical_2023.02_1Airalo.png'

export const ID_MOBILE =
  '//images.ctfassets.net/n36b8lzdmgnp/4GWwcgSULY9fb86r3J04Se/a350073422a311799cb6726f64c9e649/id-mobile-seeklogo-2_1.svg'

export const LEBARA =
  '//images.ctfassets.net/n36b8lzdmgnp/3UdblYWx5gCa8GfDcmm4YB/dea49aa9e3fcbefa4465ef782f0e605a/download_3lebara.svg'
